export default "__VITE_ASSET__DD9I9RBQ__"